"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const common_buoy_icons_1 = require("@buoyhealth/common.buoy-icons");
/**
 * Simple checkbox input that extends Material UI's Checkbox with custom icons
 *
 * API: https://material-ui.com/api/checkbox/
 * */
function Checkbox({ checkedIconProps, uncheckedIconProps, ...rest }) {
    return ((0, jsx_runtime_1.jsx)(Checkbox_1.default, { checkedIcon: ((0, jsx_runtime_1.jsx)(common_buoy_icons_1.CheckBoxIcon, { "data-testid": "checked-icon", size: 18, ...checkedIconProps })), color: "primary", icon: ((0, jsx_runtime_1.jsx)(common_buoy_icons_1.CheckBoxOutlineBlankIcon, { "data-testid": "unchecked-icon", size: 18, ...uncheckedIconProps })), ...rest }));
}
exports.default = Checkbox;
//# sourceMappingURL=index.js.map